module.exports = __webpack_public_path__ + "d7d9557b013760c64ac4f1dc546cac10.svg";